// extracted by mini-css-extract-plugin
export var container = "_45-0";
export var fallback = "_45-5";
export var fallbackIcon = "_45-6";
export var hidden = "_45-2";
export var image = "_45-3";
export var loaded = "_45-4";
export var placeholder = "_45-1";